import React, { Component } from 'react';
import Environments from '../../../../enum/Environments';
import {ScenarioTypes} from '../../../../enum/ScenarioEnum'

class ScenarioForm extends Component {
    render() {
        const {title, buttonLabel, loadData, updateFormState, scenarioId, navigator, handleAddNewScenario, handleEditScenario} = this.props;
        const {errorField, name, email, apiKey, customerApiKey, accountId, projectId, numberZones, environment, deviceDPH, type, comments} = loadData.formData;
        const {error, success, serverError} = loadData.formErrors;

        let errorMessage = null,
            successMessage = null,
            serverErrorMessage = null;

        if (error) {
            errorMessage = <div className="scenario-message alert alert-danger"> {error} </div>;
        }

        if (success) {
            successMessage = (
                <div className="scenario-message alert alert-success col-sm-4 col-sm-offset-4 text-center">
                    {success}
                </div>
            );
        }

        if (serverError) {
            serverErrorMessage = (
                <div className="scenario-message alert alert-danger col-sm-4 col-sm-offset-4 text-center">
                    {' '}
                    {serverError}{' '}
                </div>
            );
        }

        return (
            <div>
                <ol className="breadcrumb">
                    <li>
                        <a onClick={ navigator.requestScenarioManagement }>
                            Scenario Management
                        </a>
                    </li>
                    <li className="active">
                        {scenarioId ? "Edit Scenario" : "Add New Scenario"}
                    </li>
                </ol>

                <div className="edit-scenario-main-div pull-left">
                    <div className="edit-scenario-form">
                        <form>
                            <div className="edit-scenario-form-heading">{title}</div>
                            <div className="pull-left col-xs-12">
                                <div className="form-group col-xs-12 col-sm-6">
                                    <label
                                        htmlFor="scenarioName"
                                        className="pull-left"
                                        style={{color: errorField === 'name' ? 'red' : '#429bd5'}}>
                                        Scenario name *
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="scenarioName"
                                        placeholder="Scenario name"
                                        name="name"
                                        onChange={updateFormState}
                                        value={name}
                                    />
                                    { errorField === 'name' ? errorMessage : ''}
                                </div>
                                <div className="form-group col-xs-12 col-sm-6">
                                    <label
                                        htmlFor="emailId"
                                        className="pull-left"
                                        style={{color: errorField === 'email' ? 'red' : '#429bd5'}}
                                    >
                                        Email ID *
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="emailId"
                                        placeholder="Email ID"
                                        name="email"
                                        onChange={updateFormState}
                                        value={email}
                                    />
                                    {errorField === 'email' ? errorMessage : ''}
                                </div>
                            </div>

                            <div className="pull-left col-xs-12">
                                <div className="form-group col-xs-12 col-sm-6">
                                    <label
                                        htmlFor="apiKey"
                                        className="pull-left"
                                        style={{
                                            color: errorField === 'apiKey' ? 'red' : '#429bd5',
                                        }}
                                    >
                                        Application API key *
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="apiKey"
                                        placeholder="Application API key"
                                        name="apiKey"
                                        onChange={updateFormState}
                                        value={apiKey}
                                    />
                                    {errorField === 'apiKey' ? errorMessage : ''}
                                </div>
                                <div className="form-group col-xs-12 col-sm-6">
                                    <label
                                        htmlFor="customerApiKey"
                                        className="pull-left"
                                        style={{color: errorField === 'customerApiKey' ? 'red' : '#429bd5'}}
                                    >
                                        Customer API key *
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="customerApiKey"
                                        placeholder="Customer API key"
                                        name="customerApiKey"
                                        onChange={updateFormState}
                                        value={customerApiKey}
                                    />
                                    {errorField === 'customerApiKey' ? errorMessage : ''}
                                </div>
                            </div>

                            <div className="pull-left col-xs-12">
                                <div className="form-group col-xs-12 col-sm-6">
                                    <label
                                        htmlFor="accountId"
                                        className="pull-left"
                                        style={{color: errorField === 'accountId' ? 'red' : '#429bd5'}}
                                    >
                                        Account Id *
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="accountId"
                                        placeholder="Account Id"
                                        name="accountId"
                                        onChange={updateFormState}
                                        value={accountId}
                                    />
                                    {errorField === 'accountId' ? errorMessage : ''}
                                </div>
                                <div className="form-group col-xs-12 col-sm-6">
                                    <label
                                        htmlFor="projectId"
                                        className="pull-left"
                                        style={{color: errorField === 'projectId' ? 'red' : '#429bd5'}}
                                    >
                                        Project Id *
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="projectId"
                                        placeholder="Project Id"
                                        name="projectId"
                                        onChange={updateFormState}
                                        value={projectId}
                                    />
                                    {errorField === 'projectId' ? errorMessage : ''}
                                </div>
                            </div>

                            <div className="pull-left col-xs-12">
                             
                                <div className="form-group col-xs-12 col-sm-6">
                                    <label
                                        className="testDeviceType pull-left"
                                        style={{color: errorField === 'name' ? 'environment' : '#429bd5'}}
                                    >
                                        Environment *
                                    </label>
                                    <select
                                        className="form-control"
                                        id="testDeviceType"
                                        name="environment"
                                        onChange={updateFormState}
                                        value={environment}
                                    >
                                        <option>Select environment</option>
                                        <option value={Environments.uat}>UAT</option>
                                        <option value={Environments.prod}>Production</option>
                                    </select>
                                    {errorField === 'environment' ? errorMessage : ''}
                                </div>
                                <div className="form-group col-xs-12 col-sm-6">
                                    <label htmlFor="noOfZones" className="pull-left bluedotColor">
                                        Number of Zones
                                    </label>
                                    <div className="flex-center" style={{justifyContent: 'space-between'}}>
                                        <span>{numberZones}</span>
                                        { scenarioId && <button className="btn btn-default" onClick={navigator.requestZonesImport}>Zones Import</button>}
                                    </div>
                                </div>
                            </div>

                            <div className="pull-left col-xs-12">
                                <div className="form-group col-xs-12 col-sm-6">
                                    <label 
                                    htmlFor="deviceDPH" 
                                    className="pull-left"
                                    style={{color: errorField === 'deviceDPH' ? 'red' : '#429bd5'}}
                                    >
                                        Device DPH (%)
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="deviceDPH"
                                        placeholder="%"
                                        name="deviceDPH"
                                        onChange={updateFormState}
                                        value={!isNaN(deviceDPH) ? String(deviceDPH) : ""}
                                    />
                                    {errorField === 'deviceDPH' ? errorMessage : ''}
                                </div>
                                <div className="form-group col-xs-12 col-sm-6">
                                    <label
                                        className="testDeviceType pull-left"
                                        style={{color: errorField === 'name' ? 'environment' : '#429bd5'}}
                                    >
                                        Scenario Type *
                                    </label>
                                    <select
                                        className="form-control"
                                        id="scenarioType"
                                        name="type"
                                        onChange={updateFormState}
                                        value={type}
                                    >
                                        <option value={ScenarioTypes.FIELD}>Field</option>
                                        <option value={ScenarioTypes.STARTUP}>Startup</option>
                                    </select>
                                    {errorField === 'environment' ? errorMessage : ''}
                                </div>
                            </div>
                            <div className="pull-left col-xs-12">
                                <div className="form-group col-xs-12">
                                    <label htmlFor="comments" className="pull-left">
                                        Comments
                                    </label>
                                    <textarea
                                        rows="5"
                                        className="form-control"
                                        id="comments"
                                        placeholder="Comments ..."
                                        name="comments"
                                        onChange={updateFormState}
                                        value={comments}
                                    />
                                </div>
                                <div className="col-xs-6" />
                                <div className="col-xs-4">
                                    {errorMessage}
                                    {serverErrorMessage}
                                    {successMessage}
                                </div>
                                <div className="col-xs-2">
                                    <button
                                        type="button"
                                        className="btn btn-primary mainDivSubmit add-scenario-save"
                                        onClick={scenarioId ? handleEditScenario : handleAddNewScenario}
                                    >
                                        {buttonLabel}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default ScenarioForm;
